import { Tag } from 'antd';
import styled from 'styled-components';

type TagProps = {
  bgcolor: string;
};

export const StyledTag = styled(Tag)<TagProps>`
  border: transparent;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ bgcolor }) => bgcolor};
  cursor: pointer;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 2px 0;
  align-items: center;
`;

export const TextWrapper = styled.div`
  font-weight: 600;
`;
